import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export function SubirArriba() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button type="button" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} aria-label="Subir arriba" data-testid="subir-arriba-btn"
            className={`fixed right-6 bottom-24 z-40 inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-white border border-slate-200 shadow-lg text-sm font-semibold text-slate-800 hover:border-sky-400 hover:text-sky-800 transition-[opacity,transform] duration-300 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"}`}>
      <ArrowUp size={15} /> Subir arriba
    </button>
  );
}
